import { render, staticRenderFns } from "./DeliverySlots.vue?vue&type=template&id=03bc6e36"
import script from "./DeliverySlots.vue?vue&type=script&lang=js"
export * from "./DeliverySlots.vue?vue&type=script&lang=js"
import style0 from "./DeliverySlots.vue?vue&type=style&index=0&id=03bc6e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports